import { useCallback, useSyncExternalStore } from 'react';
import { clearDeferredPrompt, getDeferredPrompt, isInstalled, subscribe } from '../utils/pwa';

export type PwaInstallMode =
  | 'native' // Chrome, Edge, Samsung Internet, etc.: abre o prompt do navegador
  | 'ios' // Safari no iPhone/iPad: instrução "Compartilhar > Adicionar à Tela de Início"
  | 'safari-mac' // Safari 17+ no Mac: instrução "Arquivo > Adicionar ao Dock"
  | null; // já instalado ou navegador sem suporte

const detectManualMode = (): PwaInstallMode => {
  const ua = window.navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.includes('Macintosh') && navigator.maxTouchPoints > 1);
  if (isIOS) return 'ios';

  const isSafari = /Safari/.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Firefox/.test(ua);
  const safariVersion = Number(ua.match(/Version\/(\d+)/)?.[1] ?? 0);
  if (isSafari && ua.includes('Macintosh') && safariVersion >= 17) return 'safari-mac';

  return null;
};

const getMode = (): PwaInstallMode => {
  if (isInstalled()) return null;
  if (getDeferredPrompt()) return 'native';
  return detectManualMode();
};

export const usePwaInstall = () => {
  const mode = useSyncExternalStore(subscribe, getMode);

  const promptInstall = useCallback(async () => {
    const prompt = getDeferredPrompt();
    if (!prompt) return false;
    await prompt.prompt();
    const { outcome } = await prompt.userChoice;
    // O evento só pode ser usado uma vez; o navegador dispara outro se o usuário recusar.
    clearDeferredPrompt();
    return outcome === 'accepted';
  }, []);

  return { mode, canInstall: mode !== null, promptInstall };
};
